import { Link } from "react-router-dom";
import { Bars } from "react-loader-spinner";

//** Lib's */
import Table from "../../components/table/Table";
import BaseComponent from "../../shared/baseComponent";
import { encryptionData } from "../../utils/Encryption";

//** Service's  */
import LinkupDomainService from "../../services/domainServices/linkupDomainService";
import { hasFunctionalPermission } from "../../utils/AuthorizeNavigation/authorizeNavigation";
import { securityKey } from "../../navigation/SecurityKey";

export default class ManageLinkupRequest extends BaseComponent {

    constructor(props) {
        super(props);
        this.domainServices = new LinkupDomainService();
        this.state = {
            pagination: {
                ...this.domainServices.pagination,
                 openStatus: props.openStatus,
            },
            getList: [],
            setIsLoad: false,
            isShowAddBtn: true,
            hasViewActionPermission: true,
        };
        //console.log(props.openStatus);
        this.domainServices.onUpdateState = this.updateState.bind(this);
        this.domainServices.onActionCall = this.onActionCall.bind(this);
    }
    
    componentDidMount() {
        this.domainServices.onGetList(this.state.pagination);
        this.state.isShowAddBtn = hasFunctionalPermission(securityKey.ADDLINKUPREQUEST);
        this.state.hasViewActionPermission = hasFunctionalPermission(securityKey.VIEWLINKUPREQUEST);
    }

    //** Action Method's */
    onActionCall = (type, data) => {
        const encryptKey = encryptionData(data, 1);
        switch (type) {
            case "View":
                window.open(`/LinkupRequestDetail/id?=${encryptKey}`, "_blank");
                break;
            default:
                // Handle default case here
                break;
        }
    };
  
    render() {
        return (
            <div>
                <div className="top-search-add-button-sec mb-3">
                    <div className="row left-searchbar-sec"></div>
                    <div className="right-button-sec">
                        {this.state.isShowAddBtn?.hasAccess &&
                        <Link to="/AddLinkupRequest" className="tab-title btn-hover color-3 active" >
                            Add <span>+</span>
                        </Link>}
                    </div>
                </div>
                <div className="Linkup-list">
                    {this.state.setIsLoad ? (
                        <Bars
                            className="row"
                            wrapperStyle={{ marginTop: "150px" }}
                            color="#3c4b64"
                            height={55}
                            width="100%"
                            visible={this.state.setIsLoad}
                        />
                    ) : (
                        <Table
                            columns={this.domainServices.gridColmns}
                            rows={this.state.getList}
                            sortingColumns={[]}
                            pagination={this.state.pagination}
                            totalCount={this.state.TotalCount}
                            totalResultes={this.state.TotalCount}
                            setPagination={this.domainServices.onPageChange.bind(this)}
                            customScope={[
                                {
                                    column: "linkupRequestId",
                                    hasViewPermission: this.state.hasViewActionPermission?.hasAccess,
                                    renderTableData: this.domainServices.gridActionsViewCol.bind(this),
                                }
                            ]}
                        />
                    )}
                </div>
            </div>
        )
    }
}